import React from 'react'
import './selector.css'

export class MultiSelector extends React.Component {

  componentDidMount() {
    const { options = [] } = this.props
    const selections = options.filter( option => option.selected === true).map(option => option.value)
    this.setState({ selections })
  }

  state = {
    selections: []
  }

  onToggle = (selected, value) => {
    const {onChange} = this.props
    const selections = selected
      ? this.state.selections.concat([value])
      : this.state.selections.filter(item => item != value)
    if (onChange) onChange(selections)
    this.setState({selections})
  }

  render() {
    const { options = [], className } = this.props
    return (<ul class={`multiselector ${className}`}>
      {options.map(option => (
        <Option {...option} onToggle={this.onToggle}>
          { className === 'color' ? <span className={`colordot ${option.value}`} /> : '' }
        </Option>
      ))}
    </ul>)
  }
}

export class Option extends React.Component {

  static defaultProps = {
    selected: false
  }

  state = {
    selected: this.props.selected
  }

  toggle = () => {
    const {value, onToggle} = this.props
    const selected = !this.state.selected
    if (onToggle) onToggle(selected, value)
    this.setState({selected})
  }

  render() {
    const {label, value, selectable, children} = this.props
    const selected = this.state.selected ? 'selected' : ''
    return (<li className={`${selected} ${value}`} onClick={this.toggle}>{children}{label}</li>)
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/selector.js